<template>
  <div>
    <div
      class="footer-top ts-bottom-0"
      :style="{
        'background-image':
          'url(' + require('@/assets/front/images/bg-four.jpg') + ')'
      }"
    >
      <div class="ts-container ts-mx-auto ts-px-4">
        <div class="ts-w-full md:ts-w-1/4">
          <a href="#">
            <img
              class="ts-w-20 md:ts-w-24 ts-mx-auto md:ts-mx-0"
              src="@/assets/logo.png"
              alt="logo"
            />
          </a>
        </div>
        <div
          class="ts-grid ts-grid-cols-1 ts-gap-5 ts-text-center md:ts-text-left md:ts-grid-cols-4 md:ts-gap-20 ts-mt-12"
        >
          <div class="md:ts-col-span-1">
            <div class="footer-widget widget-about">
              <h3
                :class="$root.$i18n.locale == 'kh' ? 'ts-font-koulen ts-font-medium' : 'ts-font-heading-font ts-font-bold'"
                class="widget-title ts-capitalize ts-text-heading-color ts-text-2xl"
              >{{ $t('front.aboutGoLotto') }}</h3>
              <ul class="footer-list-menu ts-mt-5 ts-space-y-2">
                <li>
                  <a
                    @click.prevent="aboutUs"
                    href="/about-us"
                    :class="$root.$i18n.locale == 'kh' ? 'ts-font-hanuman' : 'ts-font-robot'"
                    class="ts-text-footer-link ts-text-base ts-font-normal ts-transform ts-transition-all ts-duration-200 hover:ts-no-underline hover:ts-text-maincolor hover:ts-pl-3"
                  >
                    <i class="fas fa-angle-right ts-opacity-25"></i> 
                    {{ $t('menu.aboutUs') }}
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    :class="$root.$i18n.locale == 'kh' ? 'ts-font-hanuman' : 'ts-font-robot'"
                    class="ts-text-footer-link ts-text-base ts-font-normal ts-transform ts-transition-all ts-duration-200 hover:ts-no-underline hover:ts-text-maincolor hover:ts-pl-3"
                  >
                    <i class="fas fa-angle-right ts-opacity-25"></i> {{ $t('menu.guideline') }}
                  </a>
                </li>
                <li>
                  <a
                    @click.prevent="news"
                    href="/news"
                    :class="$root.$i18n.locale == 'kh' ? 'ts-font-hanuman' : 'ts-font-robot'"
                    class="ts-text-footer-link ts-text-base ts-font-normal ts-transform ts-transition-all ts-duration-200 hover:ts-no-underline hover:ts-text-maincolor hover:ts-pl-3"
                  >
                    <i class="fas fa-angle-right ts-opacity-25"></i> {{ $t('menu.news') }}
                  </a>
                </li>
                <!-- <li>
                  <a
                    href="#0"
                    class="ts-font-robot ts-text-footer-link ts-text-base ts-font-normal ts-transform ts-transition-all ts-duration-200 hover:ts-no-underline hover:ts-text-maincolor hover:ts-pl-3"
                  >
                    <i class="fas fa-angle-right ts-opacity-25"></i> Contact
                    us
                  </a>
                </li> -->
              </ul>
            </div>
          </div>
          <div class="md:ts-col-span-1">
            <div class="footer-widget widget-links">
              <h3
                :class="$root.$i18n.locale == 'kh' ? 'ts-font-koulen ts-font-medium' : 'ts-font-heading-font ts-font-bold'" 
                class="widget-title ts-capitalize ts-text-heading-color ts-text-2xl"
              >{{ $t('front.quickLinks') }}</h3>
              <ul class="footer-list-menu ts-mt-5 ts-space-y-2">
                <!-- <li>
                  <a
                    href="#0"
                    class="
											ts-font-robot
											ts-text-footer-link 
											ts-text-base ts-font-normal
											ts-transform 
											ts-transition-all
											ts-duration-200
											hover:ts-no-underline 
											hover:ts-text-maincolor
											hover:ts-pl-3
											"
                    ><i class="fas fa-angle-right ts-opacity-25"></i> My
                    Account</a
                  >
                </li>-->
                <!-- <li>
                  <a
                    href="#0"
                    class="
											ts-font-robot
											ts-text-footer-link 
											ts-text-base ts-font-normal
											ts-transform 
											ts-transition-all
											ts-duration-200
											hover:ts-no-underline 
											hover:ts-text-maincolor
											hover:ts-pl-3"
                    ><i class="fas fa-angle-right ts-opacity-25"></i> Affiliate
                    Program</a
                  >
                </li>-->
                <li>
                  <a
                    :class="$root.$i18n.locale == 'kh' ? 'ts-font-hanuman' : 'ts-font-heading-font'" 
                    href="#"
                    class="ts-text-footer-link ts-text-base ts-font-normal ts-transform ts-transition-all ts-duration-200 hover:ts-no-underline hover:ts-text-maincolor hover:ts-pl-3"
                  >
                    <i class="fas fa-angle-right ts-opacity-25"></i> {{ $t('menu.result') }}
                  </a>
                </li>
                <li>
                  <a
                    @click.prevent="policy"
                    href="/privacies"
                    :class="$root.$i18n.locale == 'kh' ? 'ts-font-hanuman' : 'ts-font-heading-font'" 
                    class="ts-text-footer-link ts-text-base ts-font-normal ts-transform ts-transition-all ts-duration-200 hover:ts-no-underline hover:ts-text-maincolor hover:ts-pl-3"
                  >
                    <i class="fas fa-angle-right ts-opacity-25"></i> {{ $t('menu.privacyPolicy') }}
                  </a>
                </li>
                <!-- <li>
                  <a
                    href="#0"
                    class="
											ts-font-robot
											ts-text-footer-link 
											ts-text-base ts-font-normal
											ts-transform 
											ts-transition-all
											ts-duration-200
											hover:ts-no-underline 
											hover:ts-text-maincolor
											hover:ts-pl-3"
                    ><i class="fas fa-angle-right ts-opacity-25"></i> Sorteo
                    Licenses</a
                  >
                </li>-->
              </ul>
            </div>
          </div>
          <div class="md:ts-col-span-2">
            <div class="footer-widget widget-subscribe sm:ts-text-right">
              <h3
               :class="$root.$i18n.locale == 'kh' ? 'ts-font-koulen ts-font-medium' : 'ts-font-heading-font ts-font-bold'"
                class="widget-title ts-capitalize ts-text-heading-color ts-text-2xl"
              >
              {{ $t('front.contactUs') }}
              </h3>
              <div class="subscribe-part ts-mt-5 ts-mx-auto ts-w-1/3 sm:ts-float-right">
                <p class="ts-font-robot ts-text-sm ts-font-semibold">{{ contact.company_address }}</p>
                <p class="ts-font-robot ts-text-sm ts-font-semibold">{{ contact.company_phone }}</p>
                <ul
                  class="footer-social-links ts-flex ts-items-center ts-space-x-3 ts-justify-center md:ts-justify-end ts-mt-2"
                >
                  <li>
                    <a href="#0">
                      <i class="fab fa-facebook-f fa-1x"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#0">
                      <i class="fab fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#0">
                      <i class="fab fa-google-plus"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#0">
                      <i class="fab fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot-bottom ts-bg-white ts-py-6 ts-bottom-0 ts-border-t ts-border-gray-300">
      <div class="ts-container ts-mx-auto ts-px-4">
        <div class="ts-grid ts-grid-cols-1 md:ts-grid-cols-2">
          <div class="ts-text-left ts-flex ts-items-center">
            <div class="copy-right-text ts-text-center md:ts-text-left ts-w-full">
              <p class="ts-text-base ts-font-robot"
                v-if="$root.$i18n.locale == 'en'"
              >
                © 2020
                <a
                  href="#"
                  class="ts-text-maincolor ts-font-semibold hover:ts-no-underline hover:ts-text-maincolor"
                >Go Lotto</a>
                - All Rights Reserved.
              </p>
              <p class="ts-text-base ts-font-hanuman"
                v-else
              >
                ​© រក្សា​សិទ្ធិ​គ្រប់​យ៉ាង​ដោយ​
                <a
                  href="#"
                  class="ts-text-maincolor ts-font-semibold hover:ts-no-underline hover:ts-text-maincolor ts-mr-2 ts-ml-2"
                >{{ $t('front.goLotto') }}</a>
                ឆ្នាំ​២០២០.
              </p>
            </div>
          </div>
          <div class="ts-text-right">
            <!-- <ul
              class="footer-social-links ts-flex ts-items-center ts-space-x-3 ts-justify-center md:ts-justify-end"
            >
              <li>
                <a href="#0"><i class="fab fa-facebook-f fa-1x"></i></a>
              </li>
              <li>
                <a href="#0"><i class="fab fa-twitter"></i></a>
              </li>
              <li>
                <a href="#0"><i class="fab fa-google-plus"></i></a>
              </li>
              <li>
                <a href="#0"><i class="fab fa-instagram"></i></a>
              </li>
            </ul>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      contact: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.active = true
      await this.$store
        .dispatch('front/contactUs/fetch', {
          perPage: 1
        })
        .then(response => {
          this.contact = response.data[0]
        })
    },
    policy(){
      this.$router.push({ name: 'front-privacy'})
    },
    aboutUs(){
      this.$router.push({ name: 'front-about-us'})
    },
    news() {
      this.$router.push({ name: 'front-news' })
    },
  }
}
</script>

<style lang="css" scoped>
.footer-social-links li a {
  width: 33px;
  height: 33px;
  background-color: rgba(51, 181, 247, 0.1);
  border: 1px solid rgba(51, 181, 247, 0.1);
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  display: block;
  color: #676d77;
  text-align: center;
  line-height: 33px;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
}
.footer-social-links li a:hover {
  background-color: #ffffff;
  border: 1px solid rgba(51, 181, 247, 0.1);
  color: #33b5f7;
}
.footer-top {
  padding-top: 105px;
  padding-bottom: 110px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
